import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import SigninOidc from './pages/signin-oidc'
import SignoutOidc from './pages/signout-oidc'
import Home from './pages/home'
import Login from './pages/login'
import PolicyNotice from './pages/Policy'
import TermsOfUse from './pages/TermsOfUse'
import PolicyNoticePL from './pages/PolicyPL';
import TermsOfUsePL from './pages/TermsOfUsePL';
import { Provider } from 'react-redux';
import store from './store';
import userManager, { loadUserFromStorage } from './services/userService'
import AuthProvider from './utils/authProvider'
import PrivateRoute from './utils/protectedRoute'

import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

const PolicyWrapper = () => {
  const { i18n } = useTranslation();
  return i18n.language === "pl" ? <PolicyNoticePL /> : <PolicyNotice />;
};

const TermsOfUseWrapper = () => {
  const { i18n } = useTranslation();
  return i18n.language === "pl" ? <TermsOfUsePL /> : <TermsOfUse />;
};


function App() {

  useEffect(() => {
    // fetch current user from cookies
    loadUserFromStorage(store)
  }, [])

  return (
    <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <AuthProvider userManager={userManager} store={store}>
        <Router>
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/signout-oidc" component={SignoutOidc} />
            <Route path="/auth/logout" component={SignoutOidc} />
            {/* <Route path="/signin-oidc" component={SigninOidc} /> */}
            <Route path="/auth/callback" component={SigninOidc} /> 
            <Route path="/terms-of-use" component={TermsOfUseWrapper}/>
            <Route path="/privacy-policy" component={PolicyWrapper}/>
            <PrivateRoute exact path="/" component={Home} />
          </Switch>
        </Router>
      </AuthProvider>
    </Provider>
    </I18nextProvider>
  );
}

export default App;
